import { useQuery } from 'react-query';

import { COMPANION_PROFILE } from 'querykeys';

import type { CompanionProfile } from '../types';
import { getUserProfile } from '../utils/companionEndpoints';

export const useCompanionProfile = () =>
  useQuery<CompanionProfile>(COMPANION_PROFILE, getUserProfile);
